import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ApiUrl } from 'Services/Services';


function Organization() {
  const [id , setId] = useState();
  const [organization, setOrganization] = useState({
    name: '',
    description: '',
    phoneNumber: '',
    logo: '',
    userId : '',
  });

  const [logoPreview, setLogoPreview] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  // const [userID, setUserId] = useState();

  useEffect(() => {
  fetchOrganization();
}, []);

const fetchOrganization = async () => {
  try {
    const res = await axios.get(`${ApiUrl}/organization`);
    const org = res.data.data?.[0];
    if (org) {
      setOrganization(org);
      setLogoPreview(org.logo);
      setId(org.id);
      // setUserId(org?.user?.id)
      localStorage.setItem('organizationId', JSON.stringify(org.id)); // ✅ move here
    } else {
      toast.warn("No organization data found");
    }
  } catch (error) {
    console.error('Error fetching organization:', error.message);
  }
};

  const handleChange = (e) => {
    setOrganization({ ...organization, [e.target.name]: e.target.value });
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };
const handleSave = async () => {
  try {
    const formData = new FormData();
    formData.append('name', organization.name);
    formData.append('userId', 1);
    formData.append('phoneNumber', organization.phoneNumber); // Add this line

    if (logoFile) {
      formData.append('logo', logoFile);
    }

    const response = await axios.post(`${ApiUrl}/organization`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.status === 200 || response.status === 201) {
      setIsEditing(false);
      toast.success('Updated');
      fetchOrganization();
    } else {
      console.error('Unexpected response:', response.data);
    }
  } catch (error) {
    console.error(
      'Error updating/creating organization:',
      error.response?.data?.message || error.message
    );
  }
};


  return (
    <div className="p-6 max-w-5xl mx-auto bg-white rounded-xl shadow-md space-y-6 mt-8">
      <h2 className="text-2xl font-bold">Organization Details</h2>

      <div className="flex items-center gap-4">
        {logoPreview && (
          <img
            src={logoPreview}
            alt="Logo Preview"
            className="w-24 h-24 object-cover rounded border"
          />
        )}
        {isEditing && (
          <input
            type="file"
            accept="image/*"
            onChange={handleLogoChange}
            className="text-sm"
          />
        )}
      </div>

      <div>
        <label className="block font-medium">Name</label>
        {isEditing ? (
          <input
            type="text"
            name="name"
            value={organization.name}
            onChange={handleChange}
            className="border px-3 py-2 rounded w-full"
          />
        ) : (
          <p className="text-gray-800">{organization.name}</p>
        )}
      </div>
      <div>
  <label className="block font-medium">Phone Number</label>
  {isEditing ? (
    <input
      type="text"
      name="phoneNumber"
      value={organization.phoneNumber}
      onChange={handleChange}
      className="border px-3 py-2 rounded w-full"
    />
  ) : (
    <p className="text-gray-800">{organization.phoneNumber || 'N/A'}</p>
  )}
</div>


      {/* <div>
        <label className="block font-medium">Description</label>
        {isEditing ? (
          <textarea
            name="description"
            value={organization.description}
            onChange={handleChange}
            className="border px-3 py-2 rounded w-full"
            rows={3}
          />
        ) : (
          <p className="text-gray-700">{organization.description}</p>
        )}
      </div> */}

      <div className="flex justify-end gap-3">
        {isEditing ? (
          <>
            <button
              onClick={() => setIsEditing(false)}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Save
            </button>
          </>
        ) : (
          <button
            onClick={() => setIsEditing(true)}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          >
            Edit
          </button>
        )}
      </div>
    </div>
  );
}

export default Organization;
